/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServizioMensaEventoCalendarioType } from './servizio-mensa-evento-calendario-type';


export interface ServizioMensaEventoCalendarioForm { 
    data_inizio: string;
    data_fine: string;
    tipo_evento: ServizioMensaEventoCalendarioType;
    forza_evento?: boolean;
}



